import { Alert, Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetCurrentUserQuery } from "../../features/user/userApiSlice";

export const AlertBar = () => {
	const { i18n } = useTranslation();
	const {
		data: user,
		isLoading,
		isFetching,
	} = useGetCurrentUserQuery(undefined);
	const barData = user?.infoBar;

	const [open, setOpen] = useState(true);

	const handleClose = () => {
		setOpen(false);
		localStorage.setItem("info-bar-" + barData?.updatedAt, "closed");
	};

	if (
		isLoading ||
		isFetching ||
		barData?.isVisible === false ||
		!open ||
		localStorage.getItem("info-bar-" + barData?.updatedAt) === "closed"
	) {
		return null;
	}

	return (
		<>
			<Box
				sx={{
					position: "sticky",
					top: "49px",
					zIndex: 1200,
					width: "100%",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Alert
					variant="filled"
					// severity="success"
					// severity="info"
					// severity="warning"
					// severity="error"
					severity={barData?.type}
					onClose={handleClose}
					sx={{
						borderRadius: 0,
						width: "100%",
						display: "flex",
						justifyContent: "start",
						alignItems: "center",
						"& .MuiAlert-message": {
							width: "100%",
						},
					}}
				>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-start",
							gap: 2,
							width: "100%",
						}}
					>
						<Typography
							sx={{
								color: "#fff",
								display: "flex",
								alignItems: "center",
								gap: "2px",
							}}
						>
							{barData?.messages?.[`message-${i18n.language}`] ||
								barData?.messages["message-pl"]}
						</Typography>
						<Box>
							{barData?.links.length > 0 && (
								<Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
									{barData.links.map(
										(link, index) =>
											link.text &&
											link.url && (
												<Button
													key={index}
													href={link.url}
													target="_blank"
													rel="noopener noreferrer"
													sx={{
														color: "#fff",
														textDecoration: "underline",
														minWidth: "auto",
														padding: "2px 8px",
														fontSize: "0.875rem",
														"&:hover": {
															backgroundColor: "rgba(255, 255, 255, 0.1)",
														},
													}}
												>
													{link.text}
												</Button>
											)
									)}
								</Box>
							)}
						</Box>
					</Box>
				</Alert>
			</Box>
		</>
	);
};

export const AlertBarPlaceholder = () => {
	return <Box sx={{ height: "60px" }} />;
};
